import { render, staticRenderFns } from "./QuickTipsSystemConfiguration.vue?vue&type=template&id=6ffbf700&scoped=true&"
import script from "./QuickTipsSystemConfiguration.vue?vue&type=script&lang=js&"
export * from "./QuickTipsSystemConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffbf700",
  null
  
)

export default component.exports